import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import About from '../About/About';
//import OnlineCourses from '../allcourses/OnlineCourses';
import Team from '../Team/Team';
import Contact from '../Contact/Contact';
import Gallery from '../Gallery/Gallery';
import Blog from '../Blog/Blog';
import CoursePage from '../Courses/Courses';
import CubePreloader from '../preloder/preloader';
import Events from '../Events/Events';
import Navbar from '../Navbar/Navbar';

function Home() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate a delay of 2 seconds before showing the content
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  return (
    <div>
      {isLoading ? (
        <CubePreloader />
      ) : (
        <React.Fragment>
          <Navbar/>
          <Header />
          <About />
          <CoursePage />
          <Blog />
          <Team />
          <Gallery />
          <Contact />
          <Footer />
        </React.Fragment>
      )}
    </div>
  );
}

export default Home;
